export class W3CardReveal {
  partnerCardWrapper: Element | null;
  partnerCardColumns: NodeListOf<HTMLElement> | null;
  partnerContent: HTMLElement | null;
  observer!: IntersectionObserver;

  constructor() {
    this.partnerCardWrapper = document.querySelector(".card-reveal__partners");
    this.partnerCardColumns = document.querySelectorAll(".card-reveal__column");
    this.partnerContent = document.querySelector(".card-reveal__content");
    if (this.partnerCardWrapper) {
      this.setupObserver();
    }
  }

  /**
   * Setup the IntersectionObserver to observe the partner card wrapper
   */
  private setupObserver(): void {
    const options = {
      root: null, // Observing with respect to the viewport
      rootMargin: "0px",
      threshold: 0.1, // Trigger when at least 10% of the element is visible
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animateColumns();
          this.observer.unobserve(entry.target);
        }
      });
    }, options);
    if (this.partnerCardWrapper) {
      this.observer.observe(this.partnerCardWrapper);
    }
  }

  /**
   * Animate the columns based on the screen width
   */
  private animateColumns(): void {
    if (!this.partnerCardColumns) return;

    if (window.innerWidth <= 1024 && window.innerWidth > 768) {
      this.partnerCardColumns.forEach((column, index) => {
        this.animateColumn(column, index, "laptop");
      });
    } else if (window.innerWidth <= 768) {
      this.partnerCardColumns.forEach((column, index) => {
        this.animateColumn(column, index, "tablet");
      });
    } else {
      this.partnerCardColumns.forEach((column, index) => {
        this.animateColumn(column, index, "desktop");
      });
    }
  }

  /**
   * Animate the column based on the device width
   * @param device - laptop, desktop, tablet based on the screen width
   * @param column - HTMLElement of the column
   * @param columnIndex - index of the column
   */
  private animateColumn(
    column: HTMLElement,
    columnIndex: number,
    device?: string,
  ): void {
    const cardRevealPartner: HTMLElement | null = document.querySelector(
      ".card-reveal__partner",
    );

    if (!cardRevealPartner) return;

    const cardHeight = cardRevealPartner.clientHeight;
    const cardStyle = getComputedStyle(cardRevealPartner);
    const cardMarginBottom = parseInt(cardStyle.marginBottom);

    let translateY2;
    let translateY1;
    let translateCenter;

    if (device == "laptop") {
      translateY2 = -1 * cardMarginBottom;
      translateY1 =
        -1 * (cardHeight! + cardMarginBottom) * 2 + cardMarginBottom;
      translateCenter =
        -1 * (cardHeight! + cardMarginBottom) * 1.125 - cardMarginBottom;
    } else if (device == "desktop") {
      // desktop will show 2 items after the animation
      // calculate the translateY value based on the card height and margin
      translateY2 =
        -1 * (cardHeight! + cardMarginBottom) * 2 + cardMarginBottom;
      translateY1 =
        -1 * (cardHeight! + cardMarginBottom) * 4 + cardMarginBottom;
      translateCenter =
        -1 * (cardHeight! + cardMarginBottom) * 3 - cardMarginBottom;
    } else {
      translateY2 = -1 * cardMarginBottom;
      translateY1 =
        -1 * (cardHeight! + cardMarginBottom) * 3 + cardMarginBottom;
      translateCenter =
        -1 * (cardHeight! + cardMarginBottom) * 2 - cardMarginBottom;
    }

    switch (columnIndex) {
      case 0:
      case 4:
        column.style.transform = `translateY(${translateY2}px)`;
        column.style.transition =
          "transform 3.6s cubic-bezier(0.4, 0.01, 0.01, 1)";
        break;
      case 1:
      case 3:
        column.style.transform = `translateY(${translateY1}px)`;
        column.style.transition =
          "transform 3.6s cubic-bezier(0.4, 0.01, 0.01, 1)";
        break;
      case 2:
        column.style.transform = `translateY(${translateCenter}px)`;
        column.style.transition =
          "transform 3.6s cubic-bezier(0.4, 0.01, 0.01, 1)";
        break;
      default:
        break;
    }
    this.partnerContent!.style.transform = `translateY(0%)`;
  }
}
